<template>

  <div class="gray-bg" style="min-height: 100vh">
    <div class="middle-box" style="min-width: 600px; max-width: 600px">
      <!-- <div>
        {{ paymentDetail }}
      </div> -->

      <TemplateFeedback ref="pageFeedback" />

      <div class="row">

        <div class="col-9">

          <div class="ibox">

            <div class="ibox-title">
              <h5>Payment</h5>
            </div>

            <div class="ibox-content">
              <span>
                Total
              </span>

              <h2 class="font-bold">
                1.00
              </h2>

              <hr>

              <input type="hidden" name="MerchantKey" id="input_MerchantKey" v-bind:value="IPAY_MERCHANT_KEY">

              <FORM method="post" id="ePayment" name="ePayment" v-bind:action="IPAY_URL">
                <input type="hidden" name="MerchantCode" id="input_MerchantCode" v-bind:value="IPAY_MERCHANT_CODE">
                <input type="hidden" name="PaymentId" id="input_PaymentId" value="">
                <input type="hidden" name="RefNo" id="input_RefNo" value="1">
                <input type="hidden" name="Amount" id="input_Amount" value="1.00">
                <input type="hidden" name="Currency" id="input_Currency" value="MYR">
                <input type="hidden" name="ProdDesc" id="input_ProdDesc" value="">
                <input type="hidden" name="UserName" id="input_UserName" value="">
                <input type="hidden" name="UserEmail" id="input_UserEmail" value="">
                <input type="hidden" name="UserContact" id="input_UserContact" value="">
                <input type="hidden" name="Remark" id="input_Remark" value="">
                <input type="hidden" name="Lang" id="input_Lang" value="UTF-8">
                <input type="hidden" name="SignatureType" id="input_SignatureType" value="SHA256">
                <input type="hidden" name="Signature" id="input_Signature" value="">
                <input type="hidden" name="ResponseURL" id="input_ResponseURL" value="https://devpbills.parkaidemobile.com/payment/ipayResponse"> 
                <input type="hidden" name="BackendURL" id="input_BackendURL" value="https://sys2.parkaidemobile.com/api2/fund"> 
                <input type="hidden" name="Optional" id="input_Optional" value='{ "carddetails":"Y", "MDRValues":"Y" }'> 

                <div class="m-t-sm">
                  <div class="btn-group">
                    <a href="#" class="btn btn-primary btn-sm" v-on:click.prevent="paymentSubmitClick"><i class="fa fa-shopping-cart"></i> Pay </a>
                    <a href="#" class="btn btn-white btn-sm" v-on:click.prevent="paymentCancelClick"> Cancel</a>
                  </div>
                </div>

              </FORM>
            </div>

          </div>

        </div>

        <div class="col">
          <img style="width: 100px" src="/static/image/snatch_logo.png" />
        </div>

      </div>

    </div>
  </div>

</template>

<script>
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import helper from "@/components/Utility/Helper"

export default {
  name: "PageBillIpay88",
  components: {
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Collection' },
        { name: 'Bill' },
      ],

      paymentDetail: null,

      IPAY_URL: helper.IPAY_URL,
      IPAY_MERCHANT_CODE: helper.IPAY_MERCHANT_CODE,
      IPAY_MERCHANT_KEY: helper.IPAY_MERCHANT_KEY,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.paymentDetail = [];
    // this.loadBill();
  },
  methods: {
    loadBill() {
      let collectionID = this.$route.query.collectionID;
      if(!collectionID) {
        this.$refs['pageFeedback'].setFeedbackError('Invalid bill.');
        return;
      }

      let feedbackItem = 'bill collection';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/collections/' + collectionID,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.paymentDetail = response.data;
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading ' + feedbackItem);
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    paymentSubmitClick() {
      // var amount = parseFloat($('#amount').val())
      // if(!amount) {
      //   $('#amount_error').show();
      //   return;
      // } else {
      //   $('#amount_error').hide();
      //   $('#amount').val(amount.toFixed(2));
      // }

      var now = new Date().toLocaleString();
      $('#input_RefNo').val('ref ' + now);
      $('#input_ProdDesc').val('product testing ' + now);
      $('#input_Remark').val('remark ' + now);
      
      var MerchantKey = $('#input_MerchantKey').val();
      var MerchantCode = $('#input_MerchantCode').val();
      var RefNo = $('#input_RefNo').val();
      var Amount = $('#input_Amount').val();
      var Currency = $('#input_Currency').val();

      // MerchantKey = 'apple'
      // MerchantCode = 'M00003'
      // RefNo = 'A00000001'
      // Amount = '1.00'
      // Currency = 'MYR'

      var text = MerchantKey + MerchantCode + RefNo + Amount.replace('.', '') + Currency;
      // text = 'appleM00003A00000001100MYR';
      // var hash = CryptoJS.SHA256(text);
      // var signature = hash.toString(CryptoJS.enc.Base64);
      var signature = helper.iPaySHA256(text);
      $('#input_Signature').val(signature);

      $('#ePayment').submit();
    },
    paymentCancelClick() {
      window.paymentCallback(false);
      window.close();
    },
    paymentPaidClick() {
      window.paymentCallback(true);
      window.close();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Collection/PageBillIpay88.vue